import PraemienData from '@/components/praemien/praemienindexbasis';
import {praemienService} from '@/helper/httpService';
import * as actionTypes from "@/store/actionTypes";
import * as mutationTypes from "@/store/mutationTypes";
import {calculateSinglePraemie} from "@/helper/praemienHelper";
import {getAvailability} from "@/helper/availabilityHelper";
import {RIGHTS} from "@/store/user";

const state = {
  raw: {
    praemien: null,
    praemienvermieter: null
  },
  availability: null,
  tarifList: [
    { value: "basis", text: "Normal-Tarif" },
    { value: "pool", text: "Pool-Tarif" },
    { value: "securo", text: "SECURO" },
    { value: "securoplus", text: "SECUROplus" },
    { value: "securopremium", text: "SECUROpremium" },
    //{ value: "charta", text: "Charta" },
    //{ value: "comfortplan", text: "Comfortplan", disabled: true },
    //{ value: "web", text: "Internet direkt" },
    { value: "mv", text: "Mietervereins-Mitglied ohne Mietrechtsschutz vor Gericht", shortText: "MV ohne Mietrechtsschutz vor Gericht" },
    { value: "mvmg", text: "Mietervereins-Mitglied mit Mietrechtsschutz vor Gericht", shortText: "MV mit  Mietrechtsschutz vor Gericht" }
  ]
};

const getters = {
  rawPraemien: state => state.raw,
  /**
   * returned value for given key can be true, false or "schublade"
   */
  isPraemieAvailable: state => (produkt, produktlinie, sb) => {
    const availabilityKey = produktlinie + sb + produkt;
    return state.availability && state.availability[availabilityKey];
  },
  // basePraemie: state => (produkt, produktlinie, haushalt, beamter, sb, bruttojahresmiete) => {
  //   return getBasePraemieFromRaw(state.raw,  produkt, produktlinie, haushalt, beamter, sb, bruttojahresmiete);
  // },
  singlePraemie: state => (produkt, produktlinie, haushalt, beamter, sb, laufzeit, zahlweise, maklerRabatt, bruttojahresmiete, praemienMultiplier) => {
    return calculateSinglePraemie(state.raw,  produkt, produktlinie, haushalt, beamter, sb, laufzeit, zahlweise, maklerRabatt, bruttojahresmiete, praemienMultiplier);
  },
  isSusAvailable: state => !!(state.availability && state.availability["EXP" + "SB300" + "S&S PBVW+SSR"])
};

const actions = {
  [actionTypes.INIT_PRAEMIEN]: function (context, tarifId) {
    praemienService.getPrice(tarifId)
      .then(content => {
        context.commit(mutationTypes.SET_RAW_PRAEMIEN, content);
        return { defaultData: false };
      })
      .catch(err => {
        console.log(`GET PRICE failed with ${err.status}: ${err.message}`);
        // TODO check if we should use default tarif if load fails
        context.commit(mutationTypes.SET_RAW_PRAEMIEN, {
          praemien: PraemienData.praemien,
          praemienvermieter: PraemienData.praemienvermieter
        });
        return { defaultData: true };
      });
    context.commit(mutationTypes.SET_AVAILABILITY, getAvailability(
      tarifId ?
        tarifId :
        context.rootState.user.tarifname,
      context.getters.checkAuthorization(RIGHTS.TARIFSELECTION)
    ));
  }
};

const mutations = {
  [mutationTypes.SET_RAW_PRAEMIEN](state, priceobject) {
    state.raw.praemien = priceobject.praemien;
    state.raw.praemienvermieter = priceobject.praemienvermieter;
  },
  [mutationTypes.SET_AVAILABILITY](state, availability) {
    state.availability = availability;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
